/**
 * Reserves room for the horizontal scrollbar under an `autoHeight` DataGrid.
 *
 * With `autoHeight` the grid sizes its scroller to the content, which does not include the
 * horizontal scrollbar, so on a grid wide enough to scroll the bar is drawn over the bottom of the
 * last row and cuts the text in half. Only grids that both auto-size and overflow need this.
 */
export const AUTO_HEIGHT_SCROLLBAR_ROOM = {
  // On .MuiDataGrid-main, not the scroller content: MUI sets an explicit height on the content, so
  // padding there is ignored and the bar keeps sitting on the row.
  '& .MuiDataGrid-main': {
    paddingBottom: '14px'
  }
};